import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from "../AvtalsKort/DatePicker/Deadline";
import TextField from '@material-ui/core/TextField';
import FasInput from './Input/FasInput'
import Prospekt from "./Input/Prospekt";
import PrislistaInput from "./Input/PrislistaInput";
import Leverantor from "./Input/Leverantor";
import moment from 'moment';
import SelectMedArbetare from "../SkapaMote/Inputs/SelectMedArbetare";
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
//import { isEmpty } from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function InputComponent(props) {
    const classes = useStyles();
    const [state, setstate] = React.useState(props.newAvtal.Avtal);
    const [avtalType, setavtalType] = React.useState('');
    const [disabled, setDisabled] = React.useState(false);
    let LabelDd = props.intl.formatMessage({ id: 'Deadline' });
    let Description = props.intl.formatMessage({ id: 'appKontoModule.Description' });

  /*  const handleDisable = (e) => {
        setDisabled(!disabled)
    };
*/
    const getAVtalType = (avtaltype)=>{
        setstate({ ...state, avtaltyp: avtaltype });
        setavtalType(avtaltype);
        props.SetAvtalParameters(state)
    }
    const getAVtalLeverator = (Leverantor)=>{
        setstate({ ...state, Leverantor: Leverantor });
        props.SetAvtalParameters({ ...state, Leverantor: Leverantor })
    }
    const PrisListIdChange = (name,Value)=>{
        setstate({ ...state, [name]: Value });
        props.SetAvtalParameters({ ...state, [name]: Value })
        props.SetPrisListaParameters(Value)

    }
    const getAVtalAnavarig = (ansvarig)=>{
        setstate({ ...state, Ansvarig: ansvarig });
        props.SetAvtalParameters({ ...state, Ansvarig: ansvarig })
    }
    const SluthandleChange = (date)=>{
        date= moment(date).format("YYYY-MM-DD HH:mm");
        setstate({ ...state, Slutdatum: date });
        props.SetAvtalParameters({ ...state, Slutdatum: date })
    }
    const handleChangeR = (event)=>{
        setstate({ ...state, [event.target.name]: event.target.value });
    }
    const handleBlurR = (event)=>{
        props.SetAvtalParameters(state)
    }
    const handleChange = (event) => {
        setstate({ ...state, [event.target.name]: event.target.value });
        props.SetAvtalParameters({ ...state, [event.target.name]: event.target.value })
    };
    return (
        <div>
            <form className={classes.root}>
            <div className="row my-2"  style={{ height: 'auto' }}>
            <div className="col-6">
                    <FasInput 
                    phase={state.Fas}
                    ProspektFaslist={props.ProspektFaslist}
                    handleChange={handleChange}
                    />
                </div>
                {
                    parseInt(props.Flags.PrislistaIkalkyl) === 1?
                    <div className="col-6">
                    <PrislistaInput
                    PrisListId={props.newAvtal.PrisListId}
                    onChange={(e) => PrisListIdChange('PrisListId', e.target.value)}
                    />
                   </div>   
                :""}
           {/* <div className="col-6">
            <TextField
                        label={<IntlMessages id="input.Value"/>}
                        fullWidth
                        name="Varde"
                        placeholder="SEK"
                        size="small"
                        type="number"
                        value={state.Varde}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeR.bind(this)}
                        onBlur={handleBlurR.bind(this)}
                    />
                </div>
                */}
            </div>
            <div className="row my-2"  style={{ height: 'auto' }} >
                <div className="col-6">
                    <Prospekt  
                    getAVtalType={getAVtalType}
                    valueavtaltyp={state.avtaltyp}
                    />
                </div>
                <div className="col-6">
                    <Leverantor 
                        getAVtalLeverator={getAVtalLeverator}
                        avtalType={avtalType}
                        valueLeverator={state.Leverantor}
                        />
                </div>
            </div>
            <div className="row my-2"  style={{ height: 'auto' }}>
                <div className="col-6">
                    <DatePicker 
                    Lable={LabelDd}
                    isAvtal={1}
                    handleChange={SluthandleChange}
                    DateLine={state.Slutdatum}
                    />
                </div>
                <div className="col-6">
                    <TextField
                        label={<IntlMessages id="Title"/>}
                        fullWidth
                        name="Rubrik"
                        placeholder={Description}
                        size="small"
                        value={state.Rubrik}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeR.bind(this)}
                        onBlur={handleBlurR.bind(this)}
                    />
                </div>
                </div>
            <div className="row my-2"  style={{ height: 'auto' }}>
                <div className="col-6">
                         <SelectMedArbetare
                         Ansvarig={props.newAvtal.Avtal.Ansvarig}
                         disabled={false}
                         onchangeHanelansvarig={(ansvarig) => getAVtalAnavarig(parseInt(ansvarig))}   
                         />
                        </div>
            </div>
          
            <div className="row my-2"  style={{ height: 'auto' }}>
                <div  className="col-12">
                    <TextField
                        label={<IntlMessages id="Annotation"/>}
                        fullWidth
                        name="Ovrigt"
                        placeholder=""
                        size="small"
                        value={state.Ovrigt}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeR.bind(this)}
                        onBlur={handleBlurR.bind(this)}
                    />
                </div>
            </div>
               
            </form>
        </div>
    );
}
export default injectIntl(InputComponent);